import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { TabProps } from '@mui/material';
import { PublicTransitLayerEntityName } from '@api/entities/replancity_PublicTransitLine';
import { EditLineIcon } from '@icons/icons';
import { WrappedInfoIcon } from '@icons/icons/InfoIcon';
import EntityManagerCleaner from '../../../../entities/EntityManagerCleaner';
import IconTabs, { LeftTabs } from '../../../../left-panel-tabs/IconTabs';

const TransitStop = memo(() => {
    const entityName = PublicTransitLayerEntityName.STOPS;
    const { t } = useTranslation();

    const tabs: TabProps<any, LeftTabs>[] = useMemo(
        () => [
            {
                path: '',
                label: t('transit-stops.info', 'Info'),
                url: './',
                icon: <WrappedInfoIcon width={16} height={16} />,
                testId: 'stopInfoTab',
            },
            {
                path: 'edit',
                label: t('transit-stops.edit', 'Edit'),
                url: './edit',
                icon: <EditLineIcon width={16} height={16} />,
                testId: 'stopEditTab',
            },
        ],
        [t]
    );

    return (
        <>
            <IconTabs tabs={tabs} />
            <EntityManagerCleaner entityName={entityName}>
                <Outlet />
            </EntityManagerCleaner>
        </>
    );
});

export default TransitStop;
